import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      common: {
        ...store.getState().i18n.translations.en.common,
        popup: {
          ...store.getState().i18n.translations.en.common.popup,
          popupBusinessCreditReport: {
            TITLE: 'Order Business Credit Report',
            DESC: `Our business reports provide comprehensive business insights
            including company information, operational situation, financial
            viability, business risk & outlook. Using an extensive database of
            domestic and FDI businesses that are fact-checked and analyzed by
            our specialist team, we offer a variety of report types to suit
            your research needs.`,
            SERVICE_DETAIL: 'Service details',
          },
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      common: {
        ...store.getState().i18n.translations.vi.common,
        popup: {
          ...store.getState().i18n.translations.vi.common.popup,
          popupBusinessCreditReport: {
            TITLE: 'Đặt Business Credit Report',
            DESC: `Báo cáo của chúng tôi cung cấp đánh giá toàn diện về thông
            tin, tình hình hoạt động, khả năng tài chính, rủi ro & triển vọng
            doanh nghiệp. Dữ liệu về doanh nghiệp trong nước và doanh nghiệp
            FDI được đội ngũ chuyên gia của chúng tôi xác thực và phân tích,
            sản xuất nhiều loại báo cáo phù hợp với nhu cầu khách hàng.`,
            SERVICE_DETAIL: 'Chi tiết dịch vụ',
          },
        },
      },
    },
  }),
)
